export default "__VITE_ASSET__Bltf8jGF__"